/**
 * In-memory Messages AI rewrite session (per user).
 * Survives in-app tab switches; cleared on full page reload.
 */

import type { DiffHunk } from './textDiff';

export type MessagesRewriteSuggestion = {
  actionLabel: string;
  subjectHunks: DiffHunk[];
  contentHunks: DiffHunk[];
  suggestedSourceSubject: string;
  suggestedSourceContent: string;
};

export type MessagesRewriteUndoSnapshot = {
  subject: string;
  content: string;
  sourceSubject: string;
  sourceContent: string;
};

export type MessagesAiSession = {
  rewriteSuggestion: MessagesRewriteSuggestion | null;
  lastBeforeRewrite: MessagesRewriteUndoSnapshot | null;
  rewriteInstruction: string;
};

const sessions = new Map<string, MessagesAiSession>();

function isEmptySession(session: MessagesAiSession): boolean {
  return (
    !session.rewriteSuggestion &&
    !session.lastBeforeRewrite &&
    !session.rewriteInstruction.trim()
  );
}

export function loadMessagesAiSession(userId: string): MessagesAiSession | null {
  return sessions.get(userId) ?? null;
}

export function saveMessagesAiSession(userId: string, session: MessagesAiSession): void {
  if (isEmptySession(session)) {
    sessions.delete(userId);
    return;
  }
  sessions.set(userId, session);
}

export function clearMessagesAiSession(userId: string): void {
  sessions.delete(userId);
}
